<div id="multiBuildingModal" class="modal fade" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<span>{{ "PLACEHOLDER.BUILDING_SELECT" | translate }}</span>
				<button type="button" class="close" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<ng-container
					*ngFor="let b of buildings"
					class="d-flex flex-column justify-content-center align-items-center"
				>
					<button mat-stroked-button (click)="selectBuilding.emit(b)" class="w-100 my-2">
						{{ b.building_labels[0] }}
					</button>
				</ng-container>
			</div>
		</div>
	</div>
</div>
